<template>
  <button
    @click="toggleTheme"
    title="Alternar modo escuro/claro"
    class="btn d-flex text-center"
  >
    <i :class="iconClass" class="me-2"></i>
  </button>
</template>

<script>
export default {
  name: 'ButtonDarkMode',
  data() {
    return {
      currentMode: localStorage.getItem('theme') || 'light',
    };
  },
  computed: {
    iconClass() {
      return this.currentMode === 'dark' ? 'pi pi-sun text-light' : 'pi pi-moon text-dark';
    },
  },
  mounted() {
    this.applyTheme(this.currentMode);
  },
  methods: {
    applyTheme(mode) {
      const isDark = mode === 'dark';
      const htmlEl = document.documentElement;

      // 1. Lógica para Bootstrap (data-bs-theme)
      if (isDark) {
        htmlEl.setAttribute('data-bs-theme', 'dark-mode');
      } else {
        htmlEl.removeAttribute('data-bs-theme'); // Remove ou set light
      }

      // 2. Lógica para PrimeVue (Classe .app-dark)
      if (isDark) {
        htmlEl.classList.add('dark-mode');
      } else {
        htmlEl.classList.remove('dark-mode');
      }

      localStorage.setItem('theme', mode);
      this.currentMode = mode;
    },

    toggleTheme() {
      // Alterna entre 'light' e 'dark'
      const newMode = this.currentMode === 'light' ? 'dark' : 'light';
      this.applyTheme(newMode);
    },

    // handleSystemThemeChange(e) {
    //   // Opcional: Se você quiser que o botão reaja à mudança do SO
    //   const newMode = e.matches ? 'dark' : 'light';
    //   // Só muda se o usuário não tiver uma preferência manual salva, por exemplo
    //   // this.applyTheme(newMode);
    // }
  }
};
</script>